module.exports = __webpack_public_path__ + "static/there-is-a-whole-world-out-there-II-c0baf4176f2a898922148b1509f15a30.jpg";